export default function toggleImmState(propName, value, callback) {
  const realCallback = typeof value === 'function' ? value : callback;
  const realValue = typeof value === 'function' ? null : value;

  this.setImmState((data) => data.set(propName, realValue != null ? realValue : !data.get(propName)), realCallback);
}
